import React from 'react';
import cn from 'classnames';

import { ButtonProps } from 'components/widgets/Modal/defaultModalButtonProps';
import { CLOSE_BTN } from 'consts';

import { DefaultModalActionButton } from '../DefaultModalActionButton/DefaultModalActionButton';

import styles from './DefaultModalButtons.module.scss';

export interface DefaultModalButtonsProps {
  buttonsArray?: ButtonProps[];
  buttonProps?: ButtonProps;
  handleDecline: () => void;
  loading?: boolean;
  buttonCloseLabel: string;
}
// TODO: need to check the translation from POEditor for aria label
export const DefaultModalButtons = React.memo(
  ({ buttonsArray, buttonProps, handleDecline, loading, buttonCloseLabel }: DefaultModalButtonsProps) => {
    const isAnyActionButton = !!buttonsArray?.find((btn) => btn.onAccept) || buttonProps?.onAccept;

    return (
      <div
        className={cn(styles.buttons, {
          [styles.withTopBorder]: isAnyActionButton,
        })}
      >
        <button id={CLOSE_BTN} aria-label={buttonCloseLabel} tabIndex={0} className={styles.closeBtn} onClick={handleDecline} type='button' />
        {buttonsArray?.map((props) => (
          <DefaultModalActionButton
            key={props.acceptButtonText}
            loading={loading}
            onAccept={props.onAccept}
            acceptButtonText={props.acceptButtonText}
            acceptButtonType={props.acceptButtonType}
          />
        ))}
        {buttonProps && (
          <DefaultModalActionButton
            loading={loading}
            onAccept={buttonProps.onAccept}
            acceptButtonText={buttonProps.acceptButtonText}
            acceptButtonType={buttonProps.acceptButtonType}
          />
        )}
      </div>
    );
  },
);
